"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORE_KEYS = exports.isDev = void 0;
exports.isDev = process.env.NODE_ENV !== "production";
const API_BASEPATH = "https://api.fozg.net/";
exports.default = {
    USER_INFO_STORAGE_KEY: "USERINFO_Todomorrow",
    API_CURRENT_USER: API_BASEPATH + "me",
    TOKEN_KEY: "token"
};
exports.STORE_KEYS = {
    LIGHT_USER_STORE: "LIGHT_USER_STORE",
};
//# sourceMappingURL=consts.js.map